import React from 'react'
import PropTypes from 'prop-types'
import styles from './_subheading.css'
import classnames from 'classnames'
import { DesktopView, TabletView, MobileView } from '../../layout/responsive_container'

const SubHeading = (props) => {
  const {
    desktopFontSize = '16px',
    tabletFontSize = '12px',
    mobileFontSize = '12px',
  } = props
  return (
    <React.Fragment>
      <DesktopView>
        <Content {...props} fontSize={ desktopFontSize } />
      </DesktopView>
      <TabletView>
        <Content {...props} fontSize={ tabletFontSize } />
      </TabletView>
      <MobileView>
        <Content {...props} fontSize={ mobileFontSize } />
      </MobileView>
    </React.Fragment>
  )
}

function Content (props) {
  const {
    children,
    align,
    color = 'black',
    className = '',
    fontSize,
    maxWidth = '300px',
  } = props

  const inlineStyles = {
    color,
    fontSize,
    maxWidth,
  }

  const alignClass = align ? `align--${align}` : 'align--left'
  const classNames = classnames(styles.subheading, className, styles[alignClass])

  return (
    <p className={classNames} style={inlineStyles}>
      {children}
    </p>
  )
}

SubHeading.propTypes = {
  desktopFontSize: PropTypes.string,
  tabletFontSize: PropTypes.string,
  mobileFontSize: PropTypes.string,
}

Content.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  subHeadingClassName: PropTypes.string,
  fontSize: PropTypes.string,
  className: PropTypes.string,
  maxWidth: PropTypes.string,
}

export default SubHeading
